import { ButtonHTMLAttributes } from 'react';
import { StringUtils } from '@manifoldxyz/js-ts-utils';

type ButtonVersion = 'primary' | 'secondary' | 'tertiary' | 'ghost';

/**
 *
 * @ref https://www.figma.com/design/56uMhR9UpFwcheKktsqjIn/Manifold-Brand?node-id=6568-2023&m=dev
 */
export default function StyledButton({
  children,
  className,
  version = 'secondary',
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & {
  version?: ButtonVersion;
}) {
  const buttonStyle: Record<ButtonVersion, string> = {
    primary: StringUtils.classnames(
      'm-claim--w-full',
      'm-claim--rounded-md',
      'm-claim--bg-surface-contrast',
      'm-claim--px-2',
      'm-claim--py-4',
      'm-claim--text-contrast',
      'm-claim--transition-colors',
      'hover:m-claim--bg-surface-contrast/80',
      'm-claim--uppercase',
    ),
    secondary: StringUtils.classnames(
      'm-claim--w-full',
      'm-claim--rounded-md',
      'm-claim--bg-surface-secondary',
      'm-claim--px-2',
      'm-claim--py-4',
      'm-claim--transition-colors',
      'hover:m-claim--bg-surface-accent',
      'm-claim--border-2',
      'm-claim--border-surface-accent',
      'm-claim--uppercase',
    ),
    tertiary: StringUtils.classnames(
      'm-claim--w-full',
      'm-claim--rounded-md',
      'm-claim--bg-surface-tertiary',
      'm-claim--px-2',
      'm-claim--py-4',
      'm-claim--transition-colors',
      'hover:m-claim--bg-surface-tertiaryHover',
      'm-claim--uppercase',
    ),
    // used for square icons with no background that look like text
    ghost: StringUtils.classnames(
      'm-claim--w-full',
      'm-claim--text-default',
      'm-claim--bg-transparent',
      'm-claim--p-2',
      'm-claim--transition-colors',
    ),
  };

  return (
    <button
      className={StringUtils.classnames(
        buttonStyle[version as ButtonVersion],
        'm-claim--font-semimono m-claim--text-default',
        props.disabled && 'm-claim--opacity-50 m-claim--cursor-not-allowed',
        'focus:m-claim--outline-none',
        'focus-visible:m-claim--outline-none',
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
}
